import EditArea from "themes/elements/Editarea";
import InputComp from "themes/elements/Input";
import Toggle from "themes/elements/Toggle";
import style from "../../../CreateNotification/create_noti.module.scss";

function RightSection(props) {
  const {
    setTitle,
    title,
    message,
    setMessage,
    abstract,
    setAbstract,
    topNews,
    setTopNews,
  } = props;

  return (
    <div className={`flex flex-column gap-4 w-full ${style["right-section"]}`}>
      {/*Title */}
      <InputComp
        label="Title"
        placeholder="Provide title of the article"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        maxLength={200}
        showCount={true}
      />
      {/* Message  Content */}
      <EditArea
        value={message}
        onChange={(value) => {
          setMessage(value);
        }}
      />
      {/* Abstract content */}
      <InputComp
        label="Abstract content"
        placeholder="Provide abstract content to the article"
        value={abstract}
        onChange={(e) => setAbstract(e.target.value)}
      />
      {/* Setting Top news */}
      <div className="flex align-center gap-2">
        <label className="input-label">Top news :</label>
        <Toggle
          value={topNews}
          onChange={(value) => {
            setTopNews(value);
          }}
        />
      </div>
    </div>
  );
}

export default RightSection;
